import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Redux
import { useSelector, useDispatch, } from 'react-redux';
import { announcementListing } from '../../store/actions/announcement';

import { Loader, currentYear } from '../../utils/tools';
import { activityCodeDescriptions } from '../../utils/constants/activityCodes';

import { Table, 
    Button, 
    OverlayTrigger, 
    Tooltip,
    Row,
    Col,
    DropdownButton,
    Dropdown,
} from 'react-bootstrap';

import { setYear } from '../../store/reducers/uiSlice';

// Assets
import { ReactComponent as DocumentIcon } from '../../assets/document.svg';

const Announcement = () => {

    // Default init values
    const year = useSelector((state) => state.uiSlice.selectedYear);
    const thisYear = currentYear();
    const years = [thisYear, thisYear - 1, thisYear - 2, thisYear - 3, thisYear - 4];

    const dispatch = useDispatch();

    const currentBranch = useSelector(state => state.branch.current);

    useEffect(() => {
        if(currentBranch !== '')
            dispatch(announcementListing({currentBranch, year}))
    }, [dispatch, currentBranch, year]);

    const loading = useSelector(state => state.announcement.loading);
    const announcement = useSelector(state => state.announcement.listing);

    // Render Tooltips
    const renderTooltipEnter = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Otvoriť ohlásenie odpadov
        </Tooltip>
    );

     // Handlers
    const handleYearChange = (eventKey) => {
        const selectedYear = parseInt(eventKey);
        dispatch(setYear(selectedYear));
    };

    return (
        <>
            { loading ?
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '35vh' 
                }}>
                    <Loader/>
                </div>
                : 
                <div>
                    <Row>
                        <Col>
                            <DropdownButton
                                className="dropdown-custom"
                                as="div"
                                id="dropdown-variants-Years"
                                title={`${year}`}
                                onSelect={handleYearChange}
                            >
                                {years.map(y => (
                                    <Dropdown.Item key={y} eventKey={`${y}`}>{y}</Dropdown.Item>
                                ))}
                            </DropdownButton>
                        </Col>
                    </Row>

                      <div className="content pt-4 pb-4">
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th className="px-3">Typ ohlásenia odpadu</th>
                                    <th>Akcie</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(announcement) && announcement.length > 0 ? (
                                    announcement.map((data, index) => (
                                        <tr key={index}>
                                            <td className="px-3">
                                                {activityCodeDescriptions[data.activityCode] || "Neexistujúci typ ohlásenia odpadu"}
                                            </td>
                                            <td>
                                                <Button className="btnIcon">
                                                    <OverlayTrigger placement="top" overlay={renderTooltipEnter}>
                                                        <Link to={`/announcement/detail`} state={{ year: year, activityCode: data.activityCode }}>
                                                            <DocumentIcon
                                                                alt="Otvoriť ohlásenie odpadov"
                                                                className="icon icon-document"
                                                            />
                                                        </Link>
                                                    </OverlayTrigger>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="text-center text-muted py-5">
                                            <p className="mb-1"><strong>Pre zvolené obdobie neexistuje žiadne ohlásenie.</strong></p>
                                            <p className="mb-0">
                                                Začnite vytvorením <Link to="/evidencelist" className="link-custom">evidenčného listu</Link> a pridaním odpadov, ktoré chcete ohlásiť.
                                            </p>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            }
        </>
    )
}

export default Announcement;